import axios from 'axios'
import './common'

export default {
    getAllConversations: (params) => axios.get(`/conversations`, { params: params }),
    getSpecificConversation: (id, params) => axios.get(`conversations/${id}`, { params: params }),
    getUnread: () => axios.get(`/messages/nb-unread-privates`)
}